<template>
  <div class="awards">
    <h4>Inspiration Awards</h4>
    <v-list three-line>
      <v-subheader v-if="current_awards.length >= 1">{{ $t('awards_open_to_submissions') }}</v-subheader>
      <template v-for="(item, index) in current_awards">
        <v-divider v-if="index >= 1" :key="item.index" :inset="true"></v-divider>
        <v-list-tile :key="item.id" avatar :to="item.available ? `/awards/${item.id}/` : `/profiles/${item.participant_segment}/`">
          <v-list-tile-avatar :color="item['participant_segment'] | segment_color">
            <v-icon class="notranslate" dark>{{ item['submission_method'] | awards_media_type_icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-list-tile-sub-title class="text--primary">
              {{ item.available
                ? (item.submitted ? $t('has_submitted') : $t('participate'))
                : $t('Your profile must be active to participate')
              }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              {{ $t('open_until', { date: formatDate(item['closing`_date']) }) }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn depressed :color="item.available ? 'success' : 'warning'" dark class="px-3">
              {{ item.available ? $t('submit') : $t('Activate profile') }}
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </template>
      <v-subheader v-if="future_awards.length >= 1">{{ $t('future_contests') }}</v-subheader>
      <template v-for="(item, index) in future_awards">
        <v-divider v-if="index >= 1" :key="item.index" :inset="true"></v-divider>
        <v-list-tile :key="item.id" avatar>
          <v-list-tile-avatar>
            <v-icon class="notranslate" dark :color="item['participant_segment'] | segment_color">
              {{ item['submission_method'] | awards_media_type_icon }}
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-list-tile-sub-title class="text--primary">
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              {{ $t('will_open', { date: formatDate(item['opening_date']) }) }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn depressed disabled>
              {{ $t('soon') }}
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>
  </div>
</template>

<script>
  import VList from 'vuetify/es5/components/VList/VList'
  import VSubheader from 'vuetify/es5/components/VSubheader/VSubheader'
  import VAvatar from 'vuetify/es5/components/VAvatar/VAvatar'
  import VIcon from 'vuetify/es5/components/VIcon/VIcon'
  import VChip from 'vuetify/es5/components/VChip/VChip'
  import VDivider from 'vuetify/es5/components/VDivider/VDivider'
  import VBtn from 'vuetify/es5/components/VBtn/VBtn'
  import format_date_mixin from '../utils/format_date_mixin'
  import * as moment from 'moment'
  import segments_style_mixin from "../utils/segments_style_mixin";
  export default {
    name: 'Awards',
    components: {
      VBtn,
      VList,
      VSubheader,
      VAvatar,
      VIcon,
      VChip,
      VDivider
    },
    mixins: [
      format_date_mixin,
      segments_style_mixin
    ],
    data () {
      return {
        active: null
      }
    },
    computed: {
      current_awards: function () {
        const now = moment();
        return this.$store.state.user['current_awards']
            ? [...this.$store.state.user['current_awards']].filter(el => {
              return (
                  now.isSameOrAfter(el['opening_date'], 'day') &&
                  now.isSameOrBefore(el['closing_date'], 'day')
              )
            }).sort((a, b) => {
              return (new Date(a['opening_date']) > new Date(b['opening_date']))
                  ? 1
                  : ((new Date(b['opening_date']) > new Date(a['opening_date']))
                          ? -1
                          : 0
                  )
            })
            : []
      },
      future_awards: function () {
        const now = moment();
        return this.$store.state.user['current_awards']
            ? [...this.$store.state.user['current_awards']].filter(el => {
              return (now.isBefore(el['opening_date'], 'day'))
            }).sort((a, b) => {
              return (new Date(a['opening_date']) > new Date(b['opening_date']))
                  ? 1
                  : ((new Date(b['opening_date']) > new Date(a['opening_date']))
                          ? -1
                          : 0
                  )
            })
            : []
      }
    }
  }
</script>

<style lang="scss">
  h4 {
    text-align: center;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.87);
    padding: 18px 0;
  }
  .awards {
    width: 100%;
    max-width: 600px;
    margin: 24px auto;
  }
</style>

<i18n>
  {
    "en": {
      "submit": "Submit",
      "soon": "Soon",
      "open_contests": "Open contests",
      "open_until": "Contest open to submissions until {date}",
      "will_open": "Contest will open on {date}",
      "participate": "Participate in this contest",
      "has_submitted": "Your participation in this contest is confirmed",
      "awards_open_to_submissions": "Contests open to submissions",
      "future_contests": "Future contests",
      "Your profile must be active to participate": "Your profile must be active to participate",
      "Activate profile": "Activate profile"
    },
    "pt": {
      "submit": "Enviar",
      "soon": "Em breve",
      "open_contests": "Concursos abertos",
      "open_until": "Concurso aberto para envios até {date}",
      "will_open": "Concurso abrirá em {date}",
      "participate": "Participe deste concurso",
      "has_submitted": "Sua participação para este concurso está confirmada",
      "awards_open_to_submissions": "Concursos abertos para envios",
      "future_contests": "Concursos futuros",
      "Your profile must be active to participate": "Seu perfil deve estar ativo para participar",
      "Activate profile": "Ativar perfil"
    }
  }
</i18n>
